export var filterUndefined = obj => {
  var newObj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] === Object(obj[key])) newObj[key] = filterUndefined(obj[key]);else if (obj[key] !== undefined) newObj[key] = obj[key];
  });
  return newObj;
};
//# sourceMappingURL=functions.js.map